import { CheckCircle, XCircle, AlertTriangle, Info, ClipboardCheck, FileDown, X } from 'lucide-react';

const STATUS_ICON = {
  pass: { icon: CheckCircle, color: 'text-emerald-500', bg: 'bg-emerald-50 dark:bg-emerald-950/20' },
  fail: { icon: XCircle, color: 'text-rose-500', bg: 'bg-rose-50 dark:bg-rose-950/20' },
  warn: { icon: AlertTriangle, color: 'text-amber-500', bg: 'bg-amber-50 dark:bg-amber-950/20' },
  info: { icon: Info, color: 'text-blue-500', bg: 'bg-blue-50 dark:bg-blue-950/20' },
};

export default function FloorPlanChecklist({ data, onExport, exporting, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-card border border-border rounded-sm p-6 w-full max-w-lg" onClick={e => e.stopPropagation()}
        data-testid="checklist-modal">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-heading uppercase tracking-wider text-foreground flex items-center gap-2">
            <ClipboardCheck className="w-4 h-4 text-primary" /> Handoff Checklist
          </h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><X className="w-4 h-4" /></button>
        </div>

        <div className="flex items-center gap-3 mb-4 p-3 rounded-sm bg-muted/50">
          <div className="text-2xl font-heading text-foreground" data-testid="checklist-score">{data.score}%</div>
          <div className="flex-1">
            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div className={`h-full rounded-full transition-all ${data.score >= 80 ? 'bg-emerald-500' : data.score >= 50 ? 'bg-amber-500' : 'bg-rose-500'}`}
                style={{ width: `${data.score}%` }} />
            </div>
            <p className="text-[9px] text-muted-foreground mt-1">{data.ready ? 'Ready for export' : 'Some items need attention'}</p>
          </div>
        </div>

        <div className="space-y-1.5 mb-4 max-h-72 overflow-y-auto">
          {data.checklist.map(item => {
            const cfg = STATUS_ICON[item.status] || STATUS_ICON.info;
            const Icon = cfg.icon;
            return (
              <div key={item.id} className={`flex items-start gap-3 px-3 py-2.5 rounded-sm ${cfg.bg}`}
                data-testid={`checklist-${item.id}`}>
                <Icon className={`w-4 h-4 ${cfg.color} shrink-0 mt-0.5`} />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-heading text-foreground">
                    {item.label}
                    {item.required && <span className="text-[8px] text-rose-500 ml-1.5">REQUIRED</span>}
                  </p>
                  <p className="text-[10px] text-muted-foreground">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-xs text-muted-foreground border border-border rounded-sm hover:bg-muted transition-colors">
            Close
          </button>
          <button onClick={onExport} disabled={exporting} data-testid="checklist-export-btn"
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-heading uppercase tracking-wider bg-primary text-white rounded-sm hover:bg-blue-700 transition-colors disabled:opacity-50">
            <FileDown className="w-3.5 h-3.5" /> {exporting ? 'Exporting...' : 'Export Handoff PDF'}
          </button>
        </div>
      </div>
    </div>
  );
}
